import { forwardRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, type AlertLive } from '../atoms/Alert/Alert';
import { Button } from '../atoms/Button';
import { useTranslation } from '../../i18n/useTranslation';
import { aquariumSettingsPath } from '../../utils/supplySystem';

export interface ZeovitVolumeRequiredNoticeProps {
  aquariumId: string;
  live?: AlertLive;
  /** Set to -1 when focus is moved to the notice (after a refused submit). */
  tabIndex?: number;
}

/**
 * ZeoVit doses are calculated per litre (v3): shown when the aquarium has no volume
 * (stored inputs say so, or the server answered 409 AQUARIUM_VOLUME_REQUIRED). Its
 * action opens the aquarium's edit form.
 */
export const ZeovitVolumeRequiredNotice = forwardRef<HTMLDivElement, ZeovitVolumeRequiredNoticeProps>(
  function ZeovitVolumeRequiredNotice({ aquariumId, live, tabIndex }, ref) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
      <Alert
        ref={ref}
        tabIndex={tabIndex}
        tone="warning"
        live={live}
        title={t('zeovit.volume.title')}
        data-testid="zeovit-volume-required"
        action={
          <Button variant="secondary" onClick={() => navigate(aquariumSettingsPath(aquariumId))}>
            {t('zeovit.volume.openSettings')}
          </Button>
        }
      >
        {t('zeovit.volume.message')}
      </Alert>
    );
  },
);

ZeovitVolumeRequiredNotice.displayName = 'ZeovitVolumeRequiredNotice';

export default ZeovitVolumeRequiredNotice;
